// utils/logger.js
import pino from "pino";

const isDevelopment = process.env.NODE_ENV !== "production";

const logger = pino({
  level: isDevelopment ? "debug" : "error",

  // Configuration pour développement avec pino-pretty
  ...(isDevelopment && {
    transport: {
      target: "pino-pretty",
      options: {
        colorize: true,
        translateTime: "HH:MM:ss",
        ignore: "pid,hostname",
      },
    },
  }),

  // Configuration pour production (JSON structuré)
  ...(!isDevelopment && {
    formatters: {
      level: (label) => ({ level: label }),
    },
    timestamp: () => `,"timestamp":"${new Date().toISOString()}"`,
  }),
});

export default logger;
